import React, { createContext, useContext, useState, useEffect } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const libraries = ['places']; // Add more if needed

const GoogleMapsContext = createContext({
  google: null,
  isLoaded: false
});

export const GoogleMapsProvider = ({ children }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
    libraries
  });

  // Set a loading state to prevent rendering until Google Maps is loaded
  const [isMapsReady, setIsMapsReady] = useState(false);

  useEffect(() => {
    if (isLoaded) {
      setIsMapsReady(true);
    }
  }, [isLoaded]);

  if (!isMapsReady) {
    return <div></div>; // @todo: loading state?
  }

  return (
    <GoogleMapsContext.Provider value={{ google: window.google, isLoaded }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => useContext(GoogleMapsContext);
